module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_feature01-d3d58693cfcea10e25bc99c7ddbd48e5.png";